import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  paper: {
    position: 'relative',
    backgroundColor: 'white',
    border: '0',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    outline: 'none',
    height: 'auto',
    maxWidth: '87.5rem',
    width: 'calc( 100vw - 1.875rem )',
    [theme.breakpoints.up('viewportMobileMid')]: {
      width: 'calc( 100vw - 28.6% )',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      width: 'calc( 100vw - 16.66666% )',
    },
    '& p, h2, h1': {
      margin: 0,
    },
    '& ol, ul': {
      margin: '0 0 0.625rem 0',
    },
    '& p': {
      paddingBottom: '1em',
    },
  },
});
